import styled from 'styled-components';

const RaffleContentWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 2rem;
  max-width: 30%;
  padding: 30px 2.5rem;
  margin: 0 auto;
  @media only screen and (-webkit-min-device-pixel-ratio: 2) and (max-device-width: 320px){
    max-width: 100%;
    padding: 10px 2rem;
  }
  @media only screen and (-webkit-min-device-pixel-ratio: 2) and (max-device-width: 480px) and (min-device-width: 321px) {
    max-width: 90%;
    padding: 15px 2.5rem;
  }
`;

const ContentTopBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // height: 20%;
  width: 100%;
  margin: 3rem;
  a {
    width: 100%;
    &:hover {
      text-decoration: none;
    }
  }
  @media only screen and (-webkit-min-device-pixel-ratio: 2) and (max-device-width: 480px) and (min-device-width: 320px) {
    padding: 0rem 0rem;
    margin: 1.5rem;
  }
`;

const ContentCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // height: 60%;
  width: 100%;
  margin: 0rem 3rem;
  // padding: 0rem 5rem;
`;

const P = styled.p`
  margin: 0px;
  text-align: center;
`;

const ButtonDone = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  ${'' /* // height: 20%; */}
  color: ${props => props.primary ?  "#fff" : "#159953"};
  width: 70%;
  font-family: 'Nunito Bold';
  background: ${props => props.primary ? "#159953" : "#fff"};
  border: 1px solid #ccc;
  border-radius: 2rem;
  padding: 15px 12px;
  ${'' /* height: 48px; */}
  ${'' /* box-shadow: -1px 2px 1px -1px #4a4a4a; */}
  text-decoration: none;
  cursor: pointer;
  
  P {
    color: #159953;
    font-family: Century Gothic Bold;
    font-size: 14px;
    width: 60%;
    text-align: center;
  }

`;

const WrappImage = styled.div`
  display: flex;
  align-items: center;
  width: 40%; 
`;


export {
  RaffleContentWrap,
  ContentTopBottom,
  ContentCenter,
  P,
  ButtonDone,
  WrappImage
};
